import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FootballStatistic, LeagueApi,
  PublicTeamApi,
  StatisticGroupByTypes,
  TournamentApi, TournamentRoundApi,
  TournamentSeasonApi,
} from '@mtgame/core';
import { LeagueRootService } from '@core/services/league-root.service';
import { TournamentTeamService } from '@core/services/tournament-team.service';

const STORE_COMMON_STATISTIC_KEY = 'commonStatistic';
const STORE_WIN_LOSE_STATISTIC_KEY = 'winLoseStatistic';
const STORE_BY_MONTH_STATISTIC_KEY = 'byMonthStatistic';
const STORE_USERS_STATISTIC_KEY = 'usersStatistic';

@Injectable()
export class FootballTournamentTeamService extends TournamentTeamService {
  get commonStatistic$(): Observable<FootballStatistic> {
    return this.store.get(STORE_COMMON_STATISTIC_KEY);
  }

  get winLoseStatistic$(): Observable<FootballStatistic[]> {
    return this.store.get(STORE_WIN_LOSE_STATISTIC_KEY);
  }

  get byMonthStatistic$(): Observable<FootballStatistic[]> {
    return this.store.get(STORE_BY_MONTH_STATISTIC_KEY);
  }

  get usersStatistic$(): Observable<FootballStatistic[]> {
    return this.store.get(STORE_USERS_STATISTIC_KEY);
  }

  constructor(
    protected leagueRootService: LeagueRootService,
    protected leagueApi: LeagueApi,
    protected tournamentApi: TournamentApi,
    protected tournamentSeasonApi: TournamentSeasonApi,
    protected tournamentRoundApi: TournamentRoundApi,
    protected publicTeamApi: PublicTeamApi,
  ) {
    super(leagueRootService, leagueApi, tournamentApi, tournamentSeasonApi, tournamentRoundApi, publicTeamApi);
  }

  async getCommonStatistic(): Promise<FootballStatistic> {
    const statistic = await this.getStatistic('team');
    this.store.save(STORE_COMMON_STATISTIC_KEY, statistic && statistic[0] || new FootballStatistic());
    return statistic && statistic[0] || new FootballStatistic();
  }

  async getWinLoseStatistic(): Promise<FootballStatistic[]> {
    let statistic = await this.getStatistic('win_loses');
    statistic = statistic.sort((a, b) => a.winLose ? -1 : 1);
    this.store.save(STORE_WIN_LOSE_STATISTIC_KEY, statistic);
    return statistic;
  }

  async getByMonthStatistic(): Promise<FootballStatistic[]> {
    let statistic = await this.getStatistic('month');
    statistic = statistic.sort((a, b) => a.month.getTime() - b.month.getTime());
    this.store.save(STORE_BY_MONTH_STATISTIC_KEY, statistic);
    return statistic;
  }

  async getUsersStatistic(): Promise<FootballStatistic[]> {
    const statistic = await this.getStatistic('league_player');
    this.store.save(STORE_USERS_STATISTIC_KEY, statistic);
    return statistic;
  }

  protected async getStatistic(groupBy: StatisticGroupByTypes): Promise<FootballStatistic[]> {
    const statistic = await this.tournamentApi.getFootballStatistic({
      ...this.filters,
      team_id: this.teamId,
      group_by: groupBy,
      per_game: false,
    });
    return statistic.data;
  }
}
